<template>
    <div>
        <ui-section title="Importar planilha do dia" description="Arraste o .xlsx recebido por e-mail. A fonte é reconhecida pelo cabeçalho; o mesmo arquivo não entra duas vezes.">
            <ui-file-drop :file="file" accept=".xlsx,.xls,.csv" :max-size-mb="50" hint="XLSX, XLS ou CSV de até 50 MB" :loading="uploading"
                @select="file = $event" @save="upload" @error="(message) => $dialog.notify.warning(message, { position: 'top-right', timeout: 4000 })" />
            <div class="d-flex justify-end mt-4" style="gap: 8px;">
                <v-btn v-if="file" outlined :disabled="uploading" @click="file = null">Limpar</v-btn>
                <v-btn v-if="$allowed('prospect.import')" color="primary" depressed :disabled="!file" :loading="uploading" @click="upload"><v-icon left small>mdi-table-arrow-up</v-icon>Gerar prévia</v-btn>
            </div>
        </ui-section>

        <h2 class="ui-section-title mt-8 mb-3">Importações</h2>
        <ui-table-card>
            <v-data-table :headers="headers" :items="imports" :loading="loading" disable-sort hide-default-footer :items-per-page="-1"
                no-data-text="Nenhuma planilha importada" loading-text="Carregando..." class="ui-clickable-rows" @click:row="open">
                <template v-slot:[`item.created_at`]="{ item }">
                    <div class="ui-cell-main ui-nowrap">{{ formatDateTime(item.created_at) }}</div>
                    <div class="ui-cell-sub">{{ item.uploaded_by ? item.uploaded_by.name : "—" }}</div>
                </template>
                <template v-slot:[`item.original_name`]="{ item }">
                    <div class="ui-cell-main">{{ item.original_name }}</div>
                    <div class="ui-cell-sub">{{ item.source_label }}</div>
                </template>
                <template v-slot:[`item.counts`]="{ item }">
                    <span class="ui-nowrap">{{ plural(item.total_rows, "linha", "linhas") }} · <strong>{{ item.relevant_rows }}</strong> {{ item.relevant_rows === 1 ? "relevante" : "relevantes" }}<span v-if="item.review_rows"> · {{ item.review_rows }} a revisar</span></span>
                    <div class="ui-cell-sub">{{ plural(item.discarded_rows, "descartada", "descartadas") }} automaticamente</div>
                </template>
                <template v-slot:[`item.result`]="{ item }">
                    <span v-if="item.status === 'confirmed'" class="ui-nowrap">{{ plural(item.new_cases, "novo", "novos") }} · {{ plural(item.updated_cases, "atualizado", "atualizados") }}</span>
                    <span v-else class="ui-muted">—</span>
                    <div v-if="item.conflicts" class="ui-cell-sub">{{ item.conflicts }} com conflito</div>
                </template>
                <template v-slot:[`item.status`]="{ item }"><ui-badge set="prospect-import" :status="item.status" /></template>
                <template v-slot:[`item.actions`]><v-icon small class="ui-cell-chevron">mdi-chevron-right</v-icon></template>
            </v-data-table>
            <template #footer>
                <ui-pagination :total="total" :page.sync="page" :items-per-page.sync="perPage" />
            </template>
        </ui-table-card>
    </div>
</template>

<script>
// Aba "Importacoes" da tela de Casos: envio da planilha do dia (RecuperaJur ou
// BRZJ) e historico das importacoes, cada uma com a previa para conferir.
import axios from "axios";
import { chunkedUpload } from "@/common/util/chunked-upload";
import { formatDateTime, notifyError } from "@/components/prospect/prospect.util";

export default {
    name: "ProspectCaseImports",

    data: () => ({
        file: null,
        uploading: false,
        imports: [],
        loading: false,
        total: 0,
        page: 1,
        perPage: 25,
        headers: [
            { text: "Enviada em", value: "created_at", width: 170 },
            { text: "Arquivo", value: "original_name" },
            { text: "Triagem", value: "counts" },
            { text: "Resultado", value: "result", width: 200 },
            { text: "Situação", value: "status", width: 130 },
            { text: "", value: "actions", align: "end", width: 40 },
        ],
    }),

    watch: {
        page() {
            this.load();
        },
        perPage() {
            this.page = 1;
            this.load();
        },
    },

    created() {
        this.load();
    },

    methods: {
        formatDateTime,

        plural(count, one, many) {
            return `${count} ${count === 1 ? one : many}`;
        },

        async load() {
            this.loading = true;
            try {
                const result = await axios.get("/api/admin/prospect/imports", { params: { page: this.page, perPage: this.perPage } });
                this.imports = result.data.content.data;
                this.total = result.data.content.total;
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.loading = false;
            }
        },

        async upload() {
            if (!this.file || this.uploading) return;
            this.uploading = true;
            try {
                // A planilha vai pela API (em partes) e a importacao le pela chave no storage.
                const uploaded = await chunkedUpload(this.file);
                const result = await axios.post("/api/admin/prospect/imports", { key: uploaded.key, name: uploaded.name });
                this.file = null;
                this.$router.push(`/prospeccao/casos/importacoes/${result.data.content.id}`);
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.uploading = false;
            }
        },

        open(item) {
            this.$router.push(`/prospeccao/casos/importacoes/${item.id}`);
        },
    },
};
</script>
